import * as React from "react"

function TitleShapes2(props) {
  return (
    <svg
      width={36}
      height={12}
      viewBox="0 0 36 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36 8v4h-4V8h4zm-4-8v4h4V0h-4zm-8 8v4h4V8h-4zm4-4v4h4V4h-4zm-4-4v4h4V0h-4zm-8 8v4h4V8h-4zm4-4v4h4V4h-4zm-4-4v4h4V0h-4zM8 8v4h4V8H8zm4-4v4h4V4h-4zM8 0v4h4V0H8zM0 8v4h4V8H0zm4-4v4h4V4H4zM0 0v4h4V0H0z"
        fill="url(#paint0_linear_544_605)"
        fillOpacity={0.2}
      />
      <defs>
        <linearGradient
          id="paint0_linear_544_605"
          x1={-1.92861e-8}
          y1={6.5}
          x2={37}
          y2={6.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default TitleShapes2
